namespace Portico.Models.Legacy {
    
    export class EnrollmentResultModel {
        bin: string;
        cardActivationDate: Date;
        cardEndDate: Date;
        sponsorNumber: string;
        memberNumber: string;
        groupNumber: string;
        totalBenefitAmount: number;
        remainingBenefitAmount: number;
        totalPaidAmount: number;

        constructor(obj?: Portico.Services.Legacy.EnrollmentService.Models.EnrollmentResultModel){
            this.bin = null;
            this.cardActivationDate = null;
            this.cardEndDate = null;
            this.sponsorNumber = null;
            this.memberNumber = null;
            this.groupNumber = null;
            this.totalBenefitAmount = null;
            this.remainingBenefitAmount = null;
            this.totalPaidAmount = null;

            if(obj){
                this.bin = obj.bin || null;
                this.cardActivationDate = typeof obj.cardActivationDate === 'string' ? new Date(obj.cardActivationDate) : obj.cardActivationDate || null;
                this.cardEndDate = typeof obj.cardEndDate === 'string' ? new Date(obj.cardEndDate) : obj.cardEndDate || null;
                this.sponsorNumber = obj.sponsorNumber || null;
                this.memberNumber = obj.memberNumber || null;
                this.groupNumber = obj.groupNumber || null;
                this.totalBenefitAmount = obj.totalBenefitAmount || null;
                this.remainingBenefitAmount = obj.remainingBenefitAmount || null;
                this.totalPaidAmount = obj.totalPaidAmount || null;
            }
        }

        public toModel(): Portico.Services.Legacy.EnrollmentService.Models.EnrollmentResultModel {
            return {
                bin: this.bin,
                cardActivationDate: this.cardActivationDate,
                cardEndDate: this.cardEndDate,
                sponsorNumber: this.sponsorNumber,
                memberNumber: this.memberNumber,
                groupNumber: this.groupNumber,
                totalBenefitAmount: this.totalBenefitAmount,
                remainingBenefitAmount: this.remainingBenefitAmount,
                totalPaidAmount: this.totalPaidAmount,
            };
        }
    }   
}